export enum OutComeOfAfterCaseBlockResult {
  SHOW_TEST_RESULT = 'SHOW_TEST_RESULT',
  FAIL_TEST = 'FAIL_TEST',
}

export enum AfterTestCaseDataDrivenFrequency {
  ALL_ITERATIONS = 'ALL_ITERATIONS',
  EVERY_ITERATION = 'EVERY_ITERATION',
}
